import { render, staticRenderFns } from "./story-card.vue?vue&type=template&id=54d9f2bc&scoped=true&"
import script from "./story-card.vue?vue&type=script&lang=js&"
export * from "./story-card.vue?vue&type=script&lang=js&"
import style0 from "./story-card.vue?vue&type=style&index=0&id=54d9f2bc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d9f2bc",
  null
  
)

export default component.exports